import { query } from '@confluence/query-preloader-tools/entry-points/graphql.ts';

import onboardingStateGetOnboardingStateQuery, {
	type onboardingStateGetOnboardingStateQuery$data,
	type onboardingStateGetOnboardingStateQuery$variables,
} from './__generated__/onboardingStateGetOnboardingStateQuery.graphql.ts';

/**
 * Centralized preloader that fetches ALL onboarding state keys.
 * This ensures that subsequent calls to useGetOnboardingState will hit the cache
 * regardless of which subset of keys they request.
 *
 * When the experiment `confluence_centralized_onboarding_state` is enabled,
 * the query is sent with an empty keys array. The backend interprets an empty
 * keys list as "return all keys", which guarantees a complete response without
 * the frontend needing to enumerate every key.
 */
export const preloadAllOnboardingState = (): Promise<{
	data: unknown;
	hasErrors: boolean;
}> => {
	return query<
		onboardingStateGetOnboardingStateQuery$data,
		onboardingStateGetOnboardingStateQuery$variables
	>({
		query: onboardingStateGetOnboardingStateQuery,
		variables: {
			key: [],
		},
	});
};
